import { Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { onSearchRecords, AddCustomerLeadRecord, commonsActionforLeadCustomer } from "../../../action/quote_order/leadcustomer.action.js";
const SearchLeadCustomer = (props) => {
	const dispatch = useDispatch();
	const { searchData, search_lead_customer, is_module_name, searchType } = useSelector((state) => state.leadcustomerReducer);
	const searchRecord = (e) => {
		if (search_lead_customer.length > 0) {
			dispatch(onSearchRecords(e, is_module_name, search_lead_customer));
		} else {
			e.preventDefault();
		}
	};
	let ButtonCheck = false;
	if (searchData.length != undefined && is_module_name == "quote") {
		ButtonCheck = true;
	}
	if (searchData.length != undefined && searchType == "Customers" && is_module_name == "order") {
		ButtonCheck = true;
	}
	let searchType_label = is_module_name == "quote" ? "Customers" : "Leads";
	return (
		<>
			<div className="choose-lead">
				<div className="form-wrapper">
					{ButtonCheck == true ? (
						<div className="add-new-btn-container">
							<Button className="add-new-btn btn btn-secondary" onClick={(e) => dispatch(AddCustomerLeadRecord(e, "openAdd"))}>
								<span className="icon icon-plus mr-1"></span>
								<span>Add New</span>
							</Button>
						</div>
					) : null}

					<div className="search-cnt">
						<div className={`search-inner ${ButtonCheck == true && "search-bar-div"}`}>
							<form className="lead mb-0" onSubmit={(e) => searchRecord(e)}>
								<div className="form-group mb-0 wrapper-field-button">
									<div className="floating-label-input search-icon-field">
										<span className="icon icon-search ml-2 mr-1"></span>
										<input
											type="text"
											value={search_lead_customer}
											className="search-lead-field"
											placeholder="Find An Existing Record"
											onChange={(e) => dispatch(commonsActionforLeadCustomer(e.target.value, "Search_Value"))}
										/>
									</div>
									{search_lead_customer.length > 0 && <button className="btn btn-secondary go-btn">GO</button>}
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>

			{ButtonCheck == true ? (
				<div className="col-12 search-result-span">
					<span className="search-static-text">Your Search Results for</span> <span className="search-dynamic-test">"{search_lead_customer}"</span>
				</div>
			) : null}
		</>
	);
};

export default SearchLeadCustomer;
